import { defineComponent as _defineComponent } from 'vue'
import {
  AbTitle,
  AbSection,
  AbContainer,
  AbLink,
  AbIcon,
  AbSectionLayout,
  AbDescription,
  AbTag,
} from '../../../ui';
import { Spacing } from '../../../../helpers/shared-props';
import { type TextAlign } from '../../../../types';
import { computed, ref } from 'vue-demi';
import { useAnalytics, useSectionAnalytics } from '../../../../analytics';
import BlogSectionSimpleSlider from './BlogSectionSimpleSlider.vue';
import BlogSectionSimpleGrid from './BlogSectionSimpleGrid.vue';
import HtmlRenderer from '../../../ui/HtmlRenderer.vue';

interface Props {
  analytics_placement?: string | null;
  id?: string | null;
  title?: string | null;
  description?: string | null;
  textAlign?: TextAlign | null;
  moreLinkAlign?: TextAlign | null;
  link?: {
    src?: string | null;
    text: string;
    creative_name?: string | null;
  } | null;
  items: {
    image?: {
      src?: string | null;
      alt?: string | null;
    } | null;
    title: string;
    link?: string | null;
    tags?: string[] | null;
    contentAlign?: TextAlign | null;
    creative_name?: string | null;
  }[];
  gridView?: boolean | null;
  spacing?: Spacing | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BlogSectionSimple',
  props: {
    analytics_placement: null,
    id: null,
    title: null,
    description: null,
    textAlign: null,
    moreLinkAlign: null,
    link: null,
    items: null,
    gridView: { type: [Boolean, null] },
    spacing: null
  },
  setup(__props: any) {

const props = __props as {
  analytics_placement?: string | null;
  id?: string | null;
  title?: string | null;
  description?: string | null;
  textAlign?: TextAlign | null;
  moreLinkAlign?: TextAlign | null;
  link?: {
    src?: string | null;
    text: string;
    creative_name?: string | null;
  } | null;
  items: {
    image?: {
      src?: string | null;
      alt?: string | null;
    } | null;
    title: string;
    link?: string | null;
    tags?: string[] | null;
    contentAlign?: TextAlign | null;
    creative_name?: string | null;
  }[];
  gridView?: boolean | null;
  spacing?: Spacing | null;
};

const ALL_TAGS = 'All tags';



const activeTag = ref(ALL_TAGS);
const tags = computed(() => {
  const tags = [
    ...new Set(
      props.items
        ?.map((item) => item.tags ?? [])
        .flat()
        .filter(Boolean),
    ),
  ];

  if (tags.length) tags.unshift(ALL_TAGS);
  return tags;
});
const selectTag = (tag: string) => {
  activeTag.value = activeTag.value === tag ? ALL_TAGS : tag;
};
const visibleItems = computed(() =>
  activeTag.value === ALL_TAGS
    ? props.items
    : props.items?.filter((item) => item.tags?.includes(activeTag.value)),
);

const view = computed(() =>
  !props.gridView ? BlogSectionSimpleSlider : BlogSectionSimpleGrid,
);

// Analytics
const sectionRef = ref<HTMLElement | null>(null);
const analyticItems = computed(() =>
  (visibleItems.value ?? []).map((item) => ({
    destination_url: item.link ?? '',
    creative_name: item.creative_name ?? '',
  })),
);

const { trackSelectItem } = useSectionAnalytics(
  sectionRef,
  {
    placement: props.analytics_placement ?? '',
    items: analyticItems.value,
  },
  {
    mode: 'section',
    sectionName: 'BlogSectionSimple',
  },
);

const { trackSelectItem: trackSelectLink } = useAnalytics();

const handleLinkClick = () => {
  trackSelectLink('BlogSectionSimple',props.analytics_placement ?? '', [
    {
      creative_name: props.link?.creative_name ?? '',
      destination_url: props.link?.src ?? '',
    },
  ]);
};

const handleItemClickAny = (...args: unknown[]) => {
  const index = Number(args[0]);
  if (Number.isInteger(index) && index >= 0) {
    trackSelectItem(index);
  } else {
    trackSelectItem();
  }
};

return { __sfc: true,ALL_TAGS, props, activeTag, tags, selectTag, visibleItems, view, sectionRef, analyticItems, trackSelectItem, trackSelectLink, handleLinkClick, handleItemClickAny, AbTitle, AbSection, AbContainer, AbLink, AbIcon, AbSectionLayout, AbDescription, AbTag, HtmlRenderer }
}

})